/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ArrowDown, ArrowUp } from './icons';
import './HeaderDropdown.css';

class HeaderDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false, clicked: false };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onFocusoutForIE11 = this.onFocusoutForIE11.bind(this);

    this.ie11BlurRelatedTarget = null;
    this.onBlurFirst = null;
  }

  componentDidMount() {
    if (this.node !== null) {
      this.node.addEventListener('focusout', this.onFocusoutForIE11, false);
    }
  }

  componentWillUnmount() {
    if (this.node !== null) {
      this.node.removeEventListener('focusout', this.onFocusoutForIE11);
    }
  }

  onFocus() {
    this.props.onOpen();
    this.setState({ expanded: true });
  }

  onBlur(e) {
    // Note: Synthetic onBlur never has relatedTarget in IE 11 due to
    // https://github.com/facebook/react/issues/3751. A manual focusout
    // event is used for IE11 to temporarily store the relatedTarget.
    const relatedTarget = e.relatedTarget
      ? e.relatedTarget
      : this.ie11BlurRelatedTarget;

    // Has been closed forcefully by something else (modals)
    if (!this.node) {
      this.setState({ expanded: false, clicked: false });
    } else if (!this.node.contains(relatedTarget)) {
      // Otherwise, if clicked off of page
      this.setState({ expanded: false, clicked: false });
    }

    // Reset related target for IE 11 after handling the blur event.
    this.ie11BlurRelatedTarget = null;

    // In IE11 onBlur is called after onFocusout.
    if (this.onBlurFirst === null) {
      this.onBlurFirst = true;
    }
  }

  onFocusoutForIE11(e) {
    // Only set related target if the browser is IE11.
    if (!this.onBlurFirst) {
      this.ie11BlurRelatedTarget = e.relatedTarget;
    }

    // In IE11 onBlur is called after onFocusout.
    if (this.onBlurFirst === null) {
      this.onBlurFirst = false;
    }
  }

  onClick() {
    if (this.state.expanded && this.state.clicked) {
      this.setState({ expanded: false, clicked: false });
    } else if (!this.state.expanded) {
      this.props.onOpen();
      this.setState({ expanded: true, clicked: true });
    } else {
      this.setState({ clicked: true });
    }
  }

  render() {
    const contentsClassName = `header-dropdown__contents header-dropdown__contents--${this.props.align}`;

    let dropDownArrow = null;
    if (this.props.displayArrow) {
      dropDownArrow = this.state.expanded ? (
        <ArrowUp
          className="header-dropdown__icon"
          width="1.6rem"
          height="1.6rem"
        />
      ) : (
        <ArrowDown
          className="header-dropdown__icon"
          width="1.6rem"
          height="1.6rem"
        />
      );
    }
    return (
      <span
        tabIndex="0"
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        ref={node => {
          this.node = node;
        }}
        className="header-dropdown ask-list-header-menu__dropdown"
      >
        <button
          className="header-dropdown__header"
          type="button"
          onClick={this.onClick}
        >
          <span className="header-dropdown__title">{this.props.title}</span>
          {dropDownArrow}
        </button>
        {this.state.expanded ? (
          <div
            style={{ width: this.props.containerWidth }}
            className={contentsClassName}
          >
            {this.props.children}
          </div>
        ) : null}
      </span>
    );
  }
}

HeaderDropdown.defaultProps = {
  align: 'left',
  children: '',
  containerWidth: undefined,
  displayArrow: true,
  className: undefined,
  onOpen: () => {}
};

HeaderDropdown.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  containerWidth: PropTypes.string,
  displayArrow: PropTypes.bool,
  onOpen: PropTypes.func
};

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/HeaderDropdown.js